export interface BuildSitesAdvancedQueryOptions {
  sitesSource?: string;
  latitude?: number;
  longitude?: number;
  distanceMiles?: number;
  sortByDistance?: boolean;
  communities?: string[];
}

const escapeCoveoFieldValue = (value: string): string =>
  value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

export const buildSitesAdvancedQuery = ({
  sitesSource = process.env.NEXT_PUBLIC_COVEO_SITES_SOURCE || 'Avacare Protocol Sites - Dev',
  latitude,
  longitude,
  distanceMiles,
  sortByDistance = false,
  communities,
}: BuildSitesAdvancedQueryOptions = {}): string => {
  let aq = `@source="${sitesSource}"`;

  const communityFilters = (communities ?? []).map((value) => value.trim()).filter(Boolean);
  if (communityFilters.length > 0) {
    const quoted = communityFilters.map((value) => `"${escapeCoveoFieldValue(value)}"`).join(',');
    aq += ` @site_relatedcommunities==(${quoted})`;
  }

  const hasCoordinates = latitude != null && longitude != null;

  if (hasCoordinates && sortByDistance) {
    // Radius filter only when an explicit distance is provided (not on default page load).
    if (distanceMiles != null) {
      aq += ` @distance<=${distanceMiles}`;
    }
    aq += ` $qf(function:'dist(@site_lattitude, @site_longitude, ${latitude}, ${longitude})*0.000621371', fieldName: 'distance')`;
    aq += ` $sort(criteria: 'fieldascending', field: '@distance')`;
  }

  return aq;
};
